import { Injectable } from "@angular/core";
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthenticationService } from "../login/authentication/authentication.service";
import { environment } from "src/environments/environment";

@Injectable()
export class DnsInterceptor implements HttpInterceptor {
    constructor(private auth: AuthenticationService) {}

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        if (request.url.includes(environment.apiMensajeria)) {
            const req = request.clone({
                setHeaders: {
                    dns: this.auth.currentDns,
                    Tenant: this.auth.currentDns,
                    App_key: "pbus_trafico",
                },
            });
            return next.handle(req);
        }

        if (request.url.includes(environment.apiTrafico)) {
            if(!request.url.includes("authenticatedevice")){   
                const req = request.clone({
                    setHeaders: {
                        Tenant: this.auth.currentDns,
                        App_key: "pbus_trafico",
                    },
                });
                return next.handle(req);
            }
        }

        if (request.url.includes(environment.apiTaller)) {
            if(!request.url.includes("authenticatedevice")){    
                const req = request.clone({
                    setHeaders: {
                        Tenant: this.auth.currentDns,
                        App_key: "pbus_taller",
                    },
                });
                return next.handle(req);
            }
        }

        if (request.url.includes(environment.apiVTC)) {
            const req = request.clone({
                setHeaders: {
                    Tenant: this.auth.currentDns,
                    App_key: "pbus_trafico",
                },
            });
            return next.handle(req);
        }

        if (request.url.includes(environment.apiVTC)) {
            const req = request.clone({
                setHeaders: {
                    Tenant: "demo",
                    App_key: "pbus_trafico",
                },
            });
            return next.handle(req);
        }

        return next.handle(request);
    }
}
